import { useEffect } from 'react';
import { toast } from 'sonner';
import { setSew, sewState } from '../lib/sewStore';

// protection height entered in the river popup on the map -> stored in the project (section and/or river name)
export default function useRiverDyke(t, updateProject) {
  useEffect(() => {
    const f = (e) => {
      const { i, name, p0, sec, nm } = e.detail, same = (r) => r.name === name && r.pts[0][0] === p0[0] && r.pts[0][1] === p0[1];
      updateProject((pr) => {
        const R = pr.rivers; if (!R?.list) return pr;
        const byName = { ...(R.byName || {}) };
        if (nm == null) delete byName[name]; else byName[name] = nm;
        return { ...pr, rivers: { ...R, byName, list: R.list.map((r) => (same(r) ? { ...r, dyke: sec } : r)) } };
      });
      const fl = sewState().flood;
      if (fl?.rivers) setSew({ flood: { ...fl, stale: true, rivers: fl.rivers.map((r) => ({ ...r, dyke: r.i === i ? sec : r.dyke, nameDyke: r.name === name ? nm : r.nameDyke })) } });
      toast.success(t.flPopSaved);
    };
    window.addEventListener('giss-river-dyke', f); return () => window.removeEventListener('giss-river-dyke', f);
  }, [t, updateProject]);
}
